module.exports = __webpack_public_path__ + "static/media/in-number-4.7f9726da.png";